import React from "react";
import "../styles/About.scss";
import resumePDF from "../assets/Maryam_Bani-Otero_CV_en_dev.pdf"

import { FaReact, FaNodeJs } from "react-icons/fa";

import { GrMysql } from "react-icons/gr";

import {
  SiJavascript,
  SiTypescript,
  SiJquery,
  SiNextdotjs,
  SiRedux,
  SiGraphql,
  SiAdobephotoshop,
  SiAdobeillustrator,
  SiHtml5,
  SiCss3,
  SiFirebase,
} from "react-icons/si";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

function About() {
  return (
    <div className="about-page-container">
      <div className="about-container">
        <h1>Maryam Bani-Otero</h1>
        <h3>📍 Based in Montréal, Qc</h3>
        <div className="text-container">
          <p>
          I'm a passionate web developer with a creative spirit and an aching
          curiosity and yearning to learn. I majored in biochemistry and
          molecular medicine, which ignited many of life's questions at a
          molecular level. 
          </p>
          <p>
          During my major, I worked on research projects which
          I fell in love with, as I had to do a lot of problem solving and
          optimization — there wasn't a challenge that I wasn't ready to handle.
          </p>
          <p>
          Around the same time, my curiosity led me to picking up programming
          beyond what I had learned in my classes. I found myself fufilled and
          inspired in programming as I had found a new means of expressing my
          creative spirit. As someone who has been drawing digitally for over 10
          years, localhost:3000 is a new blank canvas for me to build on.
          </p>
        </div>
        <div className="icons-list"></div>
        {/* View Resume */}
        <div className="resume-container">
          <a
            href={resumePDF}
            download
            className="resume-btn"
          >
            <span className="btn-text">Download CV</span>
            <span className="btn-icon">
              <FontAwesomeIcon icon={faDownload} />
            </span>
          </a>
        </div>
      </div>
      {/* CV section here */}
      <div className="skills-container">
        <div className="heading">
          <h2>Skills</h2>
        </div>
        <div className="box-container">
          <div className="box-left">
            <div className="core box">
              <h4>Core</h4>
              <div className="skill">
                <SiJavascript />
                Javascript
              </div>
              <div className="skill">
                <SiTypescript />
                Typescript
              </div>
            </div>
            <div className="frontend box">
              <h4>Frontend</h4>
              <div className="skill">
                <SiHtml5 /> HTML5
              </div>
              <div className="skill">
                <SiCss3 /> CSS3 / Sass
              </div>
              <div className="skill">
                <FaReact /> React
              </div>
              <div className="skill">
                <SiJquery />
                jQuery
              </div>
              <div className="skill">
                <SiNextdotjs />
                Next.js
              </div>
              <div className="skill">
                <SiRedux /> Redux
              </div>
            </div>
          </div>
          <div className="box-right">
            <div className="databases box">
              <h4>Backend and Databases</h4>
              <div className="skill">
                <FaNodeJs /> Node.js
              </div>
              <div className="skill">
                <SiGraphql />
                GraphQL
              </div>
              <div className="skill">
                <GrMysql /> MySQL
              </div>
              <div className="skill">
                <SiFirebase />
                Firebase
              </div>
            </div>
            <div className="others box">
              <h4>Other tools</h4>
              <div className="skill">
                <SiAdobephotoshop />
                Adobe Photoshop
              </div>
              <div className="skill">
                <SiAdobeillustrator />
                Adobe Illustrator
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
